import axios from 'axios'
import storage from 'redux-persist/lib/storage'
import { timeCounter } from '../../utills/timeCounter'

const API_URL = process.env.REACT_APP_API_ENDPOINT || 'api'

export const DEVICES = `${API_URL}/devices`
export const LIVE_LIST = `${API_URL}/liveList`
export const LIVE_INFO = `${API_URL}/liveInfo`
export const DAILY_LIST = `${API_URL}/dailyList`
export const REBOOT_DEVICE = `${API_URL}/rebootDevice`
export const GET_CAM_SNAPSHOT = `${API_URL}/getCamSnapShot`
export const REQ_LIVE_STREAM = `${API_URL}/requestLiveStreaming`
export const GET_RECORD_VIDEO = `${API_URL}/getRecordVideo`
export const GET_SETTING_FILE = `${API_URL}/getSettingFile`
export const INVOKE_SERVER_EVENT = `${API_URL}/invokeServerEvent`
export const SET_SETTING = `${API_URL}/setSetting`
export const CAM_CHECK = `${API_URL}/camCheck`
export const GET_CUSTOMER = `${API_URL}/getCustomer`
export const GET_USER_LOG = `${API_URL}/getUserLog`
export const LOGOUT = `${API_URL}/logoutUser`
export const DEVICE_DRIVING_INFO = `${API_URL}/deviceDrivingInfo`
export const GET_FILES = `${API_URL}/getFiles`
export const SAVE_FILE = `${API_URL}/save`
export const DELETE_FILE = `${API_URL}/deleteFile`
export const USERS_TABLE = `${API_URL}/usersTable`
export const GET_FRONTEND_MANU_SETTINGS = `${API_URL}/getfrontendsettings`
export const VALIDATE_SHARED_PWD = `${API_URL}/validateSharedPwd`
export const SHARE_FILE = `${API_URL}/shareFile`
export const SHARED_FILES = `${API_URL}/sharedFiles`
export const MAGIC_LINKS = `${API_URL}/magic-links`

export function apiGetCamSnapShot(query: any, data: any) {
  const prams = new URLSearchParams(query).toString()
  timeCounter.reset()
  timeCounter.start()
  return axios.post(`${GET_CAM_SNAPSHOT}?${prams}`, data)
}

export function apiReqLiveStreaming(query: any, data: any) {
  const prams = new URLSearchParams(query).toString()

  return axios.post(`${REQ_LIVE_STREAM}?${prams}`, data)
}

export function apiGetDevices(query: any) {
  const prams = new URLSearchParams(query).toString()

  return axios.get(`${DEVICES}?${prams}`)
}

export function apiRebootDevice(query: any) {
  const prams = new URLSearchParams(query).toString()

  return axios.get(`${REBOOT_DEVICE}?${prams}`)
}

export function apiGetLiveList(query: any) {
  const prams = new URLSearchParams(query).toString()

  return axios.get(`${LIVE_LIST}?${prams}`)
}

export function apiGetDailyList(query: any) {
  const prams = new URLSearchParams(query).toString()

  return axios.get(`${DAILY_LIST}?${prams}`)
}

export function apiGetSettingFile(query: any) {
  const prams = new URLSearchParams(query).toString()

  return axios.get(`${GET_SETTING_FILE}?${prams}`)
}

export function apiGetLiveInfo(query: any) {
  const prams = new URLSearchParams(query).toString()

  return axios.get(`${LIVE_INFO}?${prams}`)
}

export function apiInvokeServerEvent(query: any) {
  const prams = new URLSearchParams(query).toString()

  return axios.get(`${INVOKE_SERVER_EVENT}?${prams}`)
}

export function apiGetRecordVideo(query: any, data: any) {
  const prams = new URLSearchParams(query).toString()
  timeCounter.reset()
  timeCounter.start()
  return axios.post(`${GET_RECORD_VIDEO}?${prams}`, data)
}

export function apiSetSetting(query: any, data: any) {
  const prams = new URLSearchParams(query).toString()

  return axios.post(`${SET_SETTING}?${prams}`, data)
}

export function apiGetDeviceDrivingInfo(data: any) {
  return axios.post(`${DEVICE_DRIVING_INFO}`, data)
}

export function apiCamCheck(query: any) {
  const prams = new URLSearchParams(query).toString()

  return axios.post(`${CAM_CHECK}?${prams}`)
}

export function apiGetCustomer(query: any) {
  const prams = new URLSearchParams(query).toString()

  return axios.get(`${GET_CUSTOMER}?${prams}`)
}

export function apiGetUserLogs(query: any) {
  const prams = new URLSearchParams(query).toString()

  return axios.get(`${GET_USER_LOG}?${prams}`)
}

export function apiLogout(data: any) {
  return axios.post(`${LOGOUT}`, data)
}

export function apiGetStoredFiles(query: any) {
  const prams = new URLSearchParams(query).toString()

  return axios.get(`${GET_FILES}?${prams}`)
}

export function apiSaveFile(bodyString: any, imageFile?: File[]) {
  var formData = new FormData()

  Object.keys(bodyString).map((key: any, i: any) => {
    formData.append(key, bodyString[key])
  })

  if (imageFile && Array.isArray(imageFile)) {
    imageFile.forEach((file) => {
      formData.append('file', file)
    })
  }

  return axios.post(`${SAVE_FILE}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export function apiDeleteFile(query: any) {
  const prams = new URLSearchParams(query).toString()

  return axios.delete(`${DELETE_FILE}?${prams}`)
}

export function apiGetUsers(query: any, data: any) {
  const prams = new URLSearchParams(query).toString()

  return axios.post(`${USERS_TABLE}?${prams}`, data)
}

export function apiGetFrontEndManuSettings() {
  return axios.get(`${GET_FRONTEND_MANU_SETTINGS}`)
}

export function apiValidateSharedPWD(data: any) {
  const prams = new URLSearchParams(data).toString()

  return axios.get(`${VALIDATE_SHARED_PWD}?${prams}`)
}

export function apiGetShareFileInfo(data: any) {

  const prams = new URLSearchParams(data).toString()

  return axios.post(`${SHARE_FILE}?${prams}`)
}

export function apiGetSharedFiles(query: any) {
  const prams = new URLSearchParams(query).toString()
  return axios.get(`${SHARED_FILES}?${prams}`)
}

export function apiGetMagicLinks(query: any) {
  const prams = new URLSearchParams(query).toString()
  return axios.get(`${MAGIC_LINKS}?${prams}`)
}

axios.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error.response.status == 401) {
      localStorage.removeItem('k')
      localStorage.removeItem('ssid')
      localStorage.removeItem('uid')
      localStorage.removeItem('p')
      storage.removeItem('persist:v1-dhg-auth')
      window.location.href = '/'
    }
    return error
  }
)
